const profile = {
  profile: {
    title: "Profile",
    personalInfo: "Personal Information",
    name: "Name",
    email: "Email",
    updateProfile: "Update Profile",
    createSelfTitle: "Create Your Profile",
    createOtherTitle: "Create New Profile",
    createSelfDesc: "To generate your personal Purple Star Astrology chart, please provide your birth information.",
    createOtherDesc: "Enter the details of the person you're creating a chart for.",
    createSelfSuccess: "Your profile has been created successfully!",
    createOtherSuccess: "The profile has been created successfully!",
    createError: "There was an error creating the profile. Please try again."
  },
  settings: {
    title: "Settings",
    theme: "Theme",
    language: "Language",
    notifications: "Notifications",
    privacy: "Privacy",
    account: "Account",
    deleteAccount: "Delete Account",
    themes: {
      light: "Light",
      dark: "Dark",
      system: "System",
    },
  },
};

export default profile; 